export enum AnalyticCategoryType {
  CITY = 'City Reviews'
}
